import type { Image } from '../types/image';

export type DateHeader = { type: 'header'; date: string };
export type ImageItem = { type: 'image'; image: Image; index: number };
export type GroupedItem = DateHeader | ImageItem;

export function getImageDate(image: Image): string {
  return (image.dateCaptured || image.uploadDate).split('T')[0];
}

export function groupImagesByDate(images: Image[]): GroupedItem[] {
  if (images.length === 0) return [];

  const items: GroupedItem[] = [];
  let currentDate: string | null = null;

  for (let i = 0; i < images.length; i++) {
    const date = getImageDate(images[i]);
    if (date !== currentDate) {
      currentDate = date;
      items.push({ type: 'header', date });
    }
    items.push({ type: 'image', image: images[i], index: i });
  }

  return items;
}

export interface DateImageGroup {
  date: string;
  images: Image[];
  startIndex: number;
}

export function getDateImageGroups(images: Image[]): DateImageGroup[] {
  if (images.length === 0) return [];

  const groups: DateImageGroup[] = [];
  let currentGroup: DateImageGroup | null = null;

  for (let i = 0; i < images.length; i++) {
    const date = getImageDate(images[i]);
    if (!currentGroup || currentGroup.date !== date) {
      currentGroup = { date, images: [], startIndex: i };
      groups.push(currentGroup);
    }
    currentGroup.images.push(images[i]);
  }

  return groups;
}
